import type { SuretyAccountId } from "@inrev/common";
import type { FC } from "react";
import { InProgressBanner } from "../patterns/in-progress-banner";
import { usePendingExtractions } from "./hooks/useHasPendingExtractions";

export type PendingExtractionsBannerProps = {
	accountId: SuretyAccountId;
	className?: string;
};

export const PendingExtractionsBanner: FC<PendingExtractionsBannerProps> = ({
	accountId,
	className,
}) => {
	const { hasPendingExtractions } = usePendingExtractions(accountId);

	if (!hasPendingExtractions) {
		return null;
	}

	return (
		<InProgressBanner testId="pending-extractions-banner" className={className}>
			One or more extractions are currently in progress.
		</InProgressBanner>
	);
};
